import { useLocation, Link } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();
  
  return (
    <div className="relative flex flex-col items-center justify-center min-h-screen text-center px-4 bg-background-50">
      <h1 className="absolute bottom-0 text-9xl md:text-[12rem] font-black text-background-100 select-none pointer-events-none z-0">
        404
      </h1>
      <div className="relative z-10">
        <div className="w-20 h-20 mx-auto mb-6 bg-background-100 rounded-full flex items-center justify-center">
          <i className="ri-error-warning-line text-foreground-400 text-3xl w-10 h-10 flex items-center justify-center"></i>
        </div>
        <h1 className="text-xl md:text-2xl font-semibold text-foreground-950 mt-6">页面未找到</h1>
        <p className="mt-2 text-sm text-foreground-500 font-mono">{location.pathname}</p>
        <p className="mt-4 text-sm text-foreground-600">您访问的页面不存在或已被移除</p>
        <Link
          to="/"
          className="mt-6 inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-background-50 rounded-full text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap"
        >
          <i className="ri-home-line w-4 h-4 flex items-center justify-center"></i>
          返回首页
        </Link>
      </div>
    </div>
  );
}